export const version = 'quarterly';
export const libraries = ['geometry', 'places'];
export const googleMapsApiKey = 'AIzaSyBg3iYyycTNutbbCzFmhd5W_kt4eodjbIQ';
